import React from 'react';
import { ShieldCheckIcon } from 'lucide-react';
export function GuaranteeSection() {
  return <section aria-labelledby="garantia" className="bg-cream" data-id="element-105" data-mp="4uqdmw6js2tb">
      <div className="mx-auto flex max-w-2xl flex-col items-center px-5 py-16 text-center lg:py-20" data-id="element-106" data-mp="4x34jyua9nii">
        <span className="flex h-14 w-14 items-center justify-center rounded-full bg-white shadow-soft" data-id="element-107" data-mp="9wpi69e0x5ru">
          <ShieldCheckIcon className="h-6 w-6 text-coral" aria-hidden="true" data-id="element-108" data-mp="er38hxdtwmpn" />
        </span>

        <h2 id="garantia" className="mt-7 font-display text-xl font-black uppercase leading-snug tracking-[0.01em] text-ink sm:text-2xl" data-id="element-109" data-mp="jqpt4rvzl58h">
          Garantía “Satisfecho o Reembolsado”
        </h2>

        <p className="mt-5 max-w-xl text-[15px] leading-relaxed text-muted sm:text-base" data-id="element-110" data-mp="xkgu3bvnjgsl">
          Prueba el material durante 7 días. Si no es lo que esperabas, te devolvemos cada peso. Sin preguntas:
          escríbenos un correo y procesamos el reembolso.
        </p>

        <a href="#politica-reembolso" className="mt-6 text-sm font-bold text-coral underline decoration-coral/50 underline-offset-4 transition-colors duration-150 ease-out-expo hover:text-coral-dark" data-id="element-111" data-mp="17fqtdruo1a2o">
          Política completa de reembolso
        </a>
      </div>
    </section>;
}